// Module
var code = `<div class="dpAttention">
    <terceraPictureBox name="warningTriangle" />

    <terceraLabel name="mainTextLabel" text="{{.messageBoxText}}" />
</div>`;
// Exports
export default code;